import { smoothScroll } from './smooth-scroll';
import { APP_SCROLL_ELEMENT } from '@doltech/core/lib/appScroll/withAppScroll';

export const scrollToQuestion = (qUuid) => {
  const elm = document.getElementById(qUuid);
  if (!elm) {
    return;
  }

  const position = elm.getBoundingClientRect();
  const questionContainer = document.getElementById('body-container');
  if (questionContainer) {
    smoothScroll(300, questionContainer, position.top);
  }
  const scrollContainer = APP_SCROLL_ELEMENT;
  if (scrollContainer) {
    smoothScroll(300, scrollContainer, elm.offsetTop);
  }
};

export const resetScrollItem = (e) => {
  const element = document.getElementById(e);
  if (!element) {
    return;
  }
  document.getElementById(e).style.transform = 'none';
  document.getElementById(e).style.overflow = null;
};

export const scrollToElementId = (
  elementId: string,
  containerEl = document.getElementById('app-root'),
  stickyTop = 0
) => {
  const sectionEl = document.getElementById(elementId);

  if (!sectionEl) {
    return;
  }

  // scroll
  smoothScroll(400, containerEl, sectionEl?.offsetTop - stickyTop);
};

export const scrollToElement = (
  element: any,
  containerEl = document.getElementById('app-root'),
  stickyTop = 0
) => {
  if (!element) {
    return;
  }

  // scroll
  smoothScroll(400, containerEl, element?.offsetTop - stickyTop);
};

export const scrollToTop = (
  containerEl = document.getElementById('app-root'),
) => {
  // scroll
  smoothScroll(400, containerEl, 0);
};
